import React, { Component, createRef } from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { withRouter } from "react-router";
import usersApi from "@/api/users";
import { handleError } from "@/util/errorHandler";
import { dateFormatter } from "@/util/formatter";
import DnDTable from "@/views/Components/DnDTable";
import TableContainerWithLocation from "@/views/Components/TableContainerWithLocation";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
import delay from "delay";

class ManageAuthorizers extends Component {
  state = {
    areAuthorizersLoading: false,
    arePotentialAuthorizersLoading: false,
    totalAuthorizers: 0,
    totalPotentialAuthorizers: 0,
    authorizersList: [],
    potentialAuthorizersList: [],
  };

  getAccountName = accountId => accountId.split("@")[0];

  onLoadAuthorizers = async params => {
    try {
      const { accountId } = this.props.match.params;
      this.setState({ areAuthorizersLoading: true });
      const { data, total } = await usersApi.getUserAuthorizersList({
        ...params,
        accountName: this.getAccountName(accountId),
      });
      this.setState({
        authorizersList: data,
        totalAuthorizers: total,
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ areAuthorizersLoading: false });
    }
  };

  onLoadPotentialAuthorizers = async params => {
    try {
      const { accountId } = this.props.match.params;
      this.setState({ arePotentialAuthorizersLoading: true });
      const { data, total } = await usersApi.getUserPotentialAuthorizers({
        ...params,
        accountName: this.getAccountName(accountId),
      });
      this.setState({
        potentialAuthorizersList: data,
        totalPotentialAuthorizers: total,
      });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ arePotentialAuthorizersLoading: false });
    }
  };

  authorizersRef = createRef();
  potentialAuthorizersRef = createRef();
  historyRef = null;

  onAddAuthorizer = async () => {
    try {
      const { accountId: currentUserId } = this.props.match.params;
      const rowId = this.potentialAuthorizersRef.current.state.selectedRows[0];
      const {
        accountId: authorizerAccountId,
      } = this.state.potentialAuthorizersList.find(({ id }) => id === rowId);
      await usersApi.addAuthorizer({
        creatorAccountId: currentUserId,
        authorizerAccountId,
      });
      swal(
        "Success!",
        `User ${authorizerAccountId} is in the process of being added as an authorizer! Please check the page later.`,
        "success",
      );
      await delay(1500);
      this.reloadData();
    } catch (err) {
      handleError(err);
    }
  };

  onRemoveAuthorizer = async () => {
    try {
      const { accountId: currentUserId } = this.props.match.params;
      const rowId = this.authorizersRef.current.state.selectedRows[0];
      const {
        accountId: authorizerAccountId,
      } = this.state.authorizersList.find(({ id }) => id === rowId);
      await usersApi.removeAuthorizer({
        creatorAccountId: currentUserId,
        authorizerAccountId,
      });
      swal(
        "Success!",
        `Authorizer ${authorizerAccountId} is in the process of being removed! Please check the page later.`,
        "success",
      );
      await delay(1500);
      this.reloadData();
    } catch (err) {
      handleError(err);
    }
  };

  reloadData = () => {
    this.authorizersRef.current.props.loadData();
    this.potentialAuthorizersRef.current.props.loadData();
    this.historyRef.loadAndStoreData();
  };

  userProfileNavigation = (cell, row) => {
    const pathname = "/kyc_info/" + row.accountId;
    const state = { data: row, previousLocation: { ...this.props.location } };

    return (
      <Link to={{ pathname, state }}>
        <div>
          <i className="fa fa-search" style={{ color: "#D15050" }} />
        </div>
      </Link>
    );
  };

  historyApiInterceptor = (...args) => {
    const { accountId } = this.props.match.params;
    const accountName = this.getAccountName(accountId);
    const [page, sizePerPage, , sort] = args;

    return usersApi.getUserAuthorizersHistory({
      accountName,
      page,
      sizePerPage,
      sort,
    });
  };

  directionDict = {
    ADD_SIGNATORY: "Addition",
    REMOVE_SIGNATORY: "Removal",
  };

  render() {
    const {
      areAuthorizersLoading,
      arePotentialAuthorizersLoading,
      authorizersList,
      totalAuthorizers,
      potentialAuthorizersList,
      totalPotentialAuthorizers,
    } = this.state;

    return (
      <div style={{ position: "relative" }}>
        <Row>
          <Col>
            <Card>
              <CardHeader>Current authorizers list</CardHeader>
              <CardBody>
                <DnDTable
                  onLoadData={this.onLoadAuthorizers}
                  isLoading={areAuthorizersLoading}
                  data={authorizersList}
                  totalEntities={totalAuthorizers}
                  columns={[
                    {
                      title: "View",
                      width: 50,
                      dataFormat: this.userProfileNavigation,
                      dataAlign: "center",
                    },
                    {
                      title: "Account ID",
                      dataField: "accountId",
                      dataSort: true,
                    },
                    {
                      title: "Organization",
                      dataField: "organizationName",
                      dataSort: true,
                    },
                  ]}
                  sourceType="AUTHORIZERS"
                  acceptsType="REST_USERS"
                  onDrop={this.onAddAuthorizer}
                  forwardRef={this.authorizersRef}
                  selectable={false}
                  showAccountTypes={false}
                />
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardHeader>Desktop users</CardHeader>
              <CardBody>
                <DnDTable
                  onLoadData={this.onLoadPotentialAuthorizers}
                  isLoading={arePotentialAuthorizersLoading}
                  data={potentialAuthorizersList}
                  totalEntities={totalPotentialAuthorizers}
                  columns={[
                    {
                      title: "View",
                      width: 50,
                      dataFormat: this.userProfileNavigation,
                      dataAlign: "center",
                    },
                    {
                      title: "Account ID",
                      dataField: "accountId",
                      dataSort: true,
                    },
                    {
                      title: "Organization",
                      dataField: "organizationName",
                      dataSort: true,
                    },
                  ]}
                  sourceType="REST_USERS"
                  acceptsType="AUTHORIZERS"
                  onDrop={this.onRemoveAuthorizer}
                  forwardRef={this.potentialAuthorizersRef}
                  selectable={false}
                  showAccountTypes={false}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Card>
          <CardHeader>History</CardHeader>
          <CardBody>
            <TableContainerWithLocation
              loadData={this.historyApiInterceptor}
              wrappedComponentRef={ref => (this.historyRef = ref)}
              options={{
                defaultSortName: "createDate", // to change default sort order also change default arguments in API users.getUserAuthorizersHistory
                defaultSortOrder: "desc",
              }}>
              <BootstrapTable
                version="4"
                pagination
                striped
                hover
                condensed
                remote
                tableBodyClass="custom-select-body-class">
                <TableHeaderColumn
                  dataSort
                  dataField="createDate"
                  dataFormat={dateFormatter}
                  dataAlign="center"
                  isKey>
                  Date
                </TableHeaderColumn>
                <TableHeaderColumn dataSort dataField="accountName">
                  Authorizer account name
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataSort
                  dataField="direction"
                  dataFormat={direction => this.directionDict[direction]}>
                  Direction
                </TableHeaderColumn>
                <TableHeaderColumn dataSort dataField="status">
                  Status
                </TableHeaderColumn>
                <TableHeaderColumn dataSort dataField="changeMadeBy">
                  Change made by
                </TableHeaderColumn>
              </BootstrapTable>
            </TableContainerWithLocation>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default withRouter(ManageAuthorizers);
